import { InjectedStyledComponent } from '../../shared/InjectedStyledComponent';

export default InjectedStyledComponent('ListItem', 'acceptanceDisclaimer', [
	'listItem',
]);
